import "./util/init.js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import store from "@/store/index.js";
import * as filter from "@/filter/filter.js";
import * as api from "@/api/api.js";
import moment from "moment"; //
import VueLazyload from "vue-lazyload";
import VueSignaturePad from "vue-signature-pad";
import { loadToken, reportBaseInfo } from "./util/index";
import VueLuckyCanvas from "@lucky-canvas/vue";
import "./util/arms";
Vue.use(VueLuckyCanvas);
Vue.use(VueLazyload);
Vue.use(VueSignaturePad);
moment.tz("Asia/Jakarta"); //
Vue.prototype.$moment = moment; //
Vue.prototype.$http = api;
Vue.config.productionTip = false;
Vue.prototype.$utils = filter;
Vue.prototype.$loadToken = loadToken;
Vue.prototype.$inAndioid =
  window.navigator.userAgent == "Android_WebView2020_kredi360";
Vue.prototype.$reportBaseInfo = reportBaseInfo;

Object.keys(filter).forEach(item => {
  Vue.filter(item, filter[item]);
});
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
